import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { NotificationSharedItemAction } from './NotificationSharedItemAction';
export const CitizenDocumentsReceivedActions = memo(({ notification, navigateTo }) => (_jsx(NotificationSharedItemAction, { notification: notification, targetPath: navigateTo })));
